import OrderOptimizerListResponse, {
  OrderOptimizerListResponseItem,
  OrderOptimizerListResponseItemOrders,
  OrderOptimizerListResponseItemRoute,
  OrderOptimizerListResponseItemStatus,
} from "../../../api/raily/order-optimizer/list/order-optimizer-list.response";
import OrderOptimizerList, {
  OrderOptimizerListItem,
  OrderOptimizerListItemOrders,
  OrderOptimizerListItemRoute,
  OrderOptimizerListItemStatus,
} from "./order-optimizer-list";

const createOrder = (
  responseItemOrder: OrderOptimizerListResponseItemOrders,
): OrderOptimizerListItemOrders => {
  const order: OrderOptimizerListItemOrders = {
    cargoCompany: responseItemOrder.cargoCompany,
    humanId: responseItemOrder.humanId,
    startTime: responseItemOrder.startTime,
    taxiCorporation: responseItemOrder.taxiCorporation,
    haltingTimeBefore: responseItemOrder.haltingTimeBefore ?? 0,
  };

  return order;
};

const createOrders = (
  responseItemOrders: OrderOptimizerListResponseItemOrders[],
): OrderOptimizerListItemOrders[] => {
  return responseItemOrders.map(createOrder);
};

const createOrderRoute = (
  responseItemOrderRoute: OrderOptimizerListResponseItemRoute,
): OrderOptimizerListItemRoute => {
  const route: OrderOptimizerListItemRoute = {
    orderHumanId: responseItemOrderRoute.orderHumanId,
    lat: responseItemOrderRoute.lat,
    lon: responseItemOrderRoute.lon,
  };

  return route;
};

const createOrderRoutes = (
  responseItemOrderRoute: OrderOptimizerListResponseItemRoute[],
): OrderOptimizerListItemRoute[] => {
  return responseItemOrderRoute.map(createOrderRoute);
};

const createStatus = (
  status: OrderOptimizerListResponseItemStatus,
): OrderOptimizerListItemStatus => {
  switch (status) {
    case OrderOptimizerListResponseItemStatus.INTERESTING:
      return OrderOptimizerListItemStatus.INTERESTING;
    case OrderOptimizerListResponseItemStatus.PENDING:
      return OrderOptimizerListItemStatus.PENDING;
    case OrderOptimizerListResponseItemStatus.REJECTED:
      return OrderOptimizerListItemStatus.REJECTED;
  }
};

const createItem = (
  responseItem: OrderOptimizerListResponseItem,
): OrderOptimizerListItem => {
  const item: OrderOptimizerListItem = {
    id: responseItem.id,
    orders: createOrders(responseItem.orders),
    reviewedAt: responseItem.reviewedAt,
    reviewedBy: responseItem.reviewedBy,
    route: createOrderRoutes(responseItem.route),
    score: responseItem.score,
    status: createStatus(responseItem.status),
  };

  return item;
};

const createData = (
  responseData: OrderOptimizerListResponseItem[],
): OrderOptimizerListItem[] => {
  return responseData.map(createItem);
};

const create = (response: OrderOptimizerListResponse): OrderOptimizerList => {
  const orderOptimizerList: OrderOptimizerList = {
    data: createData(response.data.data),
    totalCount: response.data.totalCount,
  };

  return orderOptimizerList;
};

const createForEmptyData = (): OrderOptimizerList => {
  return {
    data: [],
    totalCount: 0,
  };
};

const orderOptimizerListFactory = {
  create,
  createForEmptyData,
};

export default orderOptimizerListFactory;
